import script from "./PhotoCarroussel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhotoCarroussel.vue?vue&type=script&lang=ts&setup=true"

import "./PhotoCarroussel.vue?vue&type=style&index=0&id=266b7856&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266b7856"]])

export default __exports__